"use client"

import { useToggleState } from "@medusajs/ui"
import { ArrowRightMini } from "@medusajs/icons"
import { clx } from "@medusajs/ui"

import LanguageSelect from "@modules/layout/components/language-select"
import { Locale } from "@lib/data/locales"

type FooterLanguageSelectProps = {
  locales: Locale[]
  currentLocale: string | null
}

const FooterLanguageSelect = ({
  locales,
  currentLocale,
}: FooterLanguageSelectProps) => {
  const languageToggleState = useToggleState()

  return (
    <div
      className="flex items-center gap-x-2 text-ui-fg-muted"
      onMouseEnter={languageToggleState.open}
      onMouseLeave={languageToggleState.close}
    >
      <LanguageSelect
        toggleState={languageToggleState}
        locales={locales}
        currentLocale={currentLocale}
      />
      <ArrowRightMini
        className={clx(
          "transition-transform duration-150",
          languageToggleState.state ? "-rotate-90" : ""
        )}
      />
    </div>
  )
}

export default FooterLanguageSelect
